
import React from 'react';

interface LegalModalProps {
  type: 'terms' | 'gdpr' | 'cookies';
  onClose: () => void;
}

const LegalModal: React.FC<LegalModalProps> = ({ type, onClose }) => {
  const content = {
    terms: {
      title: "Termeni și Condiții de Utilizare",
      subtitle: "LexSmart AI - Partenerul tău Digital",
      text: (
        <>
          <h5 className="font-black text-slate-900 mt-6 mb-2">1. Acceptarea Termenilor</h5>
          <p>Prin accesarea platformei LexSmart AI, sunteți de acord să respectați acești termeni. Platforma este destinată exclusiv profesioniștilor din domeniul juridic.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">2. Asistența AI și Responsabilitatea</h5>
          <p>LexSmart utilizează algoritmi de Inteligență Artificială Generativă. Rezultatele oferite sunt instrumente de asistență și nu constituie consultanță juridică. Decizia finală și verificarea corectitudinii textelor generate revin exclusiv utilizatorului (avocatul înscris în barou).</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">3. Abonamente și Plăți</h5>
          <p>Accesul se face pe bază de abonament lunar (15€ tva inclus). Neplata la termen suspendă automat accesul la funcțiile AI și monitorizarea dosarelor.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">4. Utilizarea Datelor de pe Portal</h5>
          <p>Platforma interoghează portalquery.just.ro în numele utilizatorului. LexSmart nu este responsabilă pentru perioadele de inactivitate ale serverelor oficiale ale Ministerului Justiției.</p>
        </>
      )
    },
    gdpr: {
      title: "Politica de Confidențialitate (GDPR)",
      subtitle: "Protecția Datelor în Cloud-ul LexSmart",
      text: (
        <>
          <h5 className="font-black text-slate-900 mt-6 mb-2">1. Colectarea Datelor</h5>
          <p>Colectăm datele necesare operării: Nume, Email, Baroul de apartenență și datele tehnice ale dosarelor introduse pentru monitorizare.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">2. Securitatea și Stocarea</h5>
          <p>Toate datele sunt stocate în centre de date securizate conform standardelor ISO 27001. Documentele încărcate pentru rezumat sunt procesate în instanțe private și nu sunt utilizate pentru antrenarea modelelor publice de AI.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">3. Drepturile Dumneavoastră</h5>
          <p>Aveți dreptul de acces, rectificare și ștergere ("dreptul de a fi uitat"). Puteți exporta toate datele cabinetului dumneavoastră din secțiunea Performață în format CSV.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">4. Secretul Profesional</h5>
          <p>LexSmart respectă natura confidențială a relației avocat-client. Nu vindem și nu partajăm datele dumneavoastră cu terțe părți în scopuri de marketing.</p>
        </>
      )
    },
    cookies: {
      title: "Politica privind Modulele Cookies",
      subtitle: "Eficiență și Securitate Tehnică",
      text: (
        <>
          <h5 className="font-black text-slate-900 mt-6 mb-2">1. Ce sunt modulele Cookie?</h5>
          <p>Modulele cookie sunt fișiere text de mici dimensiuni stocate pe dispozitivul dumneavoastră pentru a îmbunătăți experiența de utilizare a platformei LexSmart.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">2. Cookies Strict Necesare (Sesiune)</h5>
          <p>Acestea sunt esențiale pentru a vă permite să rămâneți autentificat în aplicație și pentru a asigura comunicarea securizată cu API-ul Gemini AI. Fără acestea, serviciul nu poate funcționa.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">3. Cookies de Funcționalitate</h5>
          <p>Utilizăm cookies pentru a reține preferințele dumneavoastră de interfață (de exemplu, tema vizuală sau ultimele dosare accesate) pentru a vă oferi un flux de lucru rapid.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">4. Analiză și Performanță</h5>
          <p>Utilizăm date anonimizate pentru a înțelege cum interacționează avocații cu asistentul AI, în scopul optimizării timpului de răspuns și al relevanței drafturilor juridice.</p>
          
          <h5 className="font-black text-slate-900 mt-6 mb-2">5. Controlul Utilizatorului</h5>
          <p>Puteți restricționa utilizarea acestora din setările browserului, însă acest lucru va limita drastic funcționalitățile inteligente ale LexSmart.</p>
        </>
      )
    }
  };

  const active = content[type];

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-md z-[300] flex items-center justify-center p-4 md:p-6">
      <div className="bg-white w-full max-w-3xl rounded-[2.5rem] md:rounded-[3.5rem] shadow-2xl border border-white animate-in zoom-in-95 duration-200 flex flex-col max-h-[90dvh] overflow-hidden">
        <div className="p-6 md:p-10 border-b border-slate-50 flex justify-between items-center shrink-0">
          <div>
            <span className="text-[10px] font-black text-indigo-600 bg-indigo-50 px-3 py-1 rounded-lg uppercase tracking-widest mb-2 md:mb-3 inline-block italic">Document Legal Oficial</span>
            <h3 className="text-xl md:text-3xl font-black text-slate-900 tracking-tight italic leading-tight">{active.title}</h3>
          </div>
          <button 
            onClick={onClose}
            className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-2xl bg-slate-50 text-slate-400 hover:text-rose-500 transition-all text-2xl active:scale-90"
          >
            ×
          </button>
        </div>
        
        {/* Container pentru text cu scrollbar global stilizat */}
        <div className="p-6 md:p-10 overflow-y-auto custom-scrollbar flex-grow bg-white">
          <div className="prose prose-slate max-w-none text-slate-600 text-xs md:text-sm leading-relaxed font-medium italic pb-12 pr-4">
            <p className="font-black text-slate-400 uppercase text-[8px] md:text-[9px] tracking-widest mb-6 md:mb-8">Ultima actualizare: 12 Martie 2024</p>
            {active.text}
          </div>
        </div>

        <div className="p-6 md:p-8 bg-slate-50 border-t border-slate-100 flex justify-end shrink-0">
          <button 
            onClick={onClose}
            className="w-full md:w-auto px-10 py-4 bg-indigo-600 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-indigo-700 transition-all shadow-xl shadow-indigo-100 active:scale-95"
          >
            Am citit și sunt de acord
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
